import React from "react";
import { EvtHeader } from "components/header";
import OpeningForm from "../form";
import { useParams } from "react-router-dom";

export default function UpdateOpening() {
  const { openingId } = useParams();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Opening" />
      <div className="max-w-md p-4 lg:p-6">
        <OpeningForm openingId={openingId} />
      </div>
    </div>
  );
};
